import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { RestTimezone } from '@main-application/management/pages/system-configuration/components/date-time-configuration/model/timezone';
import { TimezoneEntityHelper } from '@main-application/management/pages/system-configuration/components/timezone-entity.helper';

import {
  RestDynamicInspectionModel,
  RestDynamicInspectionUpdateModel,
} from '../models/rest-inspections-model.interface';

@Injectable()
export class DynamicInspectionService {
  constructor(private restApiService: RestapiService) {}

  private static fixTimezoneForRestInspectionsModelList(data: RestDynamicInspectionModel[], timezone: RestTimezone) {
    data.forEach(e => TimezoneEntityHelper.fixTimezoneForRestDynamicInspectionsModelToClient(e, timezone));
    return data;
  }

  getById(inspectionId: number): Observable<RestDynamicInspectionModel> {
    return this.restApiService.getData<RestDynamicInspectionModel>(`dynamicInspections/${inspectionId}`);
  }

  list(portfolioId: number) {
    return this.restApiService.getData<RestDynamicInspectionModel[]>(
      `dynamicInspections?portfolioId=${portfolioId}`,
      DynamicInspectionService.fixTimezoneForRestInspectionsModelList
    );
  }

  create(inspection: RestDynamicInspectionUpdateModel): Observable<RestDynamicInspectionModel> {
    return this.restApiService.create<RestDynamicInspectionModel>(`dynamicInspections`, inspection);
  }

  update(inspection: RestDynamicInspectionUpdateModel): Observable<RestDynamicInspectionModel> {
    return this.restApiService.update<RestDynamicInspectionModel>(`dynamicInspections`, inspection);
  }

  delete(inspectionId: number) {
    return this.restApiService.delete<void>(`dynamicInspections/${inspectionId}`);
  }
}
